export default function Events() {
	return <section id="events">
		<h1>L33T Events</h1>
		<div className="-eventlist">
			<div>
				<img src="/img/legendsbetl33tcup.png" alt="legendsbet" />
				<div>LEGENDS.BET L33T CUP</div>
				<div>
					<a href="https://liquipedia.net/counterstrike/LEGENDS.BET_L33T_CUP">Liquipedia</a> / <a href="https://www.hltv.org/events/5170/legends-bet-l33t-cup">HLTV</a>
				</div>
			</div>
			<div>
				<img src="/img/cyberpro_emblem.png" alt="cyberpro" />
				<div>cyberPRO Series 1</div>
				<div>
					<a href="https://liquipedia.net/counterstrike/CyberPRO/Series_1">Liquipedia</a> / <a href="https://www.hltv.org/events/5441/cyberpro-series-1">HLTV</a>
				</div>
			</div>
		</div>
	</section>
}
